import React from 'react'
import { FlexContainer, Tile, Snack } from '@reapit/elements'

type outageMemoProps = {
  outageMessage?: string
  outageSeverity?: number
}

const outageMemo: React.FC<outageMemoProps> = ({ outageMessage, outageSeverity }) => {
  return (
    <>
      {outageMessage ? <FlexContainer hasMaxWidth isFlexColumn><Tile><Snack intent={outageSeverity && outageSeverity == 3?'warning':'danger'} icon="warning">{outageMessage}</Snack></Tile></FlexContainer> : null}
    </>
  )
}

export default outageMemo
